import { render, staticRenderFns } from "./videoSelectorCard.vue?vue&type=template&id=3d61e8c8&scoped=true"
import script from "./videoSelectorCard.vue?vue&type=script&lang=js"
export * from "./videoSelectorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61e8c8",
  null
  
)

export default component.exports